/**
 * Светофор ноги калькулятора: правда только с кассы.
 *
 * Серый — сверка эту ногу не видит (или чтение старше SITE_FRESH_MS).
 * Lock — касса на месте, линия снята. Кэф ещё может стоять.
 * Зелёный / жёлтый / красный — только когда нога свежая: иначе точка врёт.
 * Жёлтый — ещё плюс, но заметно хуже первого двойного чтения касс.
 * Красный — ROI ≤ 0. Считаем Decimal, как деньги.
 */

import { Decimal } from 'decimal.js';

export type SightTone = 'gray' | 'green' | 'yellow' | 'red' | 'lock';

/** Дольше — касса молчит, не «мертва». */
export const SITE_FRESH_MS = 4000;

/** Абсолютный просад ROI в пунктах процента: 0.50 = полпроцента. */
const YELLOW_ABS = new Decimal('0.50');

/** Относительный просад края: осталось меньше 85% от рождения. */
const YELLOW_KEEP = new Decimal('0.85');

export function sightTone(input: {
  siteAgeMs: number | null;
  nowRoiPct: string | number | null;
  bornRoiPct: string | null;
  now?: number;
  shut?: boolean;
}): SightTone {
  if (input.shut === true) return 'lock';
  if (input.siteAgeMs === null || input.siteAgeMs > SITE_FRESH_MS) return 'gray';
  if (input.nowRoiPct === null) return 'gray';
  let now: Decimal;
  try {
    now = new Decimal(String(input.nowRoiPct));
  } catch {
    return 'gray';
  }
  if (!now.isFinite()) return 'gray';
  if (now.lte(0)) return 'red';
  if (input.bornRoiPct === null) return 'green';
  let born: Decimal;
  try {
    born = new Decimal(input.bornRoiPct);
  } catch {
    return 'green';
  }
  if (!born.isFinite() || born.lte(0)) return 'green';
  const drop = born.minus(now);
  const thin = now.lt(born.times(YELLOW_KEEP));
  if (drop.gte(YELLOW_ABS) || thin) return 'yellow';
  return 'green';
}

export function sightTitle(tone: SightTone, ageMs: number | null): string {
  if (tone === 'gray') return 'кассу не вижу — кэф не с площадки';
  const age =
    ageMs === null ? '' : ageMs < 1000 ? 'сейчас' : `${Math.floor(ageMs / 1000)} с назад`;
  if (tone === 'lock') return `ставка заблокирована${age ? `, касса ${age}` : ''}`;
  if (tone === 'green') return `вилка жива${age ? `, касса ${age}` : ''}`;
  if (tone === 'yellow') return `вилка хуже, чем брали${age ? `, касса ${age}` : ''}`;
  return `вилка мертва${age ? `, касса ${age}` : ''}`;
}
